module.exports = new __parcel__URL__("carouselHubElementThumbnail-dark.394e0d80.svg").toString();